/**
 * Search Toggle: desktop/tablet shows inline search bar; mobile opens off-canvas menu with search focus.
 */
const MOBILE_BREAKPOINT = 768;

const SearchToggle = {
    init() {
        const headerToggle = document.querySelector('.header__actions [data-search-toggle], .header-new__actions [data-search-toggle]');
        const navMenu = document.querySelector('[data-nav-menu]');
        const searchInline = document.querySelector('[data-search-inline]');
        const input = searchInline?.querySelector('.header__search-input');
        const form = searchInline?.querySelector('[data-search-form]');
        const inlineSubmit = searchInline?.querySelector('[data-search-toggle]');

        if (!headerToggle || !navMenu || !searchInline || !input) return;

        headerToggle.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            if (window.innerWidth < MOBILE_BREAKPOINT) {
                this.openMobileSearch();
            } else {
                this.isOpen() ? this.closeSearch() : this.openSearch();
            }
        });

        inlineSubmit?.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            input.value.trim() ? form?.submit() : this.closeSearch();
        });

        input.addEventListener('blur', () => {
            setTimeout(() => {
                if (input.value.trim() === '') this.closeSearch();
            }, 100);
        });

        document.addEventListener('keydown', (e) => {
            if (e.key === 'Escape') this.closeSearch();
        });

        form?.addEventListener('submit', (e) => {
            if (input.value.trim() === '') {
                e.preventDefault();
                input.focus();
            }
        });
    },

    isMobile: () => window.innerWidth < MOBILE_BREAKPOINT,

    isOpen() {
        return document.querySelector('[data-search-inline]')?.hidden === false;
    },

    openMobileSearch() {
        const offCanvas = document.querySelector('.off-canvas--menu');
        if (!offCanvas) return;

        // Collapse all nav sections
        offCanvas.querySelectorAll('.off-canvas__nav-item').forEach(item => {
            item.classList.add('is-collapsed');
        });

        if (!offCanvas.classList.contains('off-canvas--visible')) {
            offCanvas.classList.add('off-canvas--visible');
            document.body.classList.add('off-canvas-menu-open', 'off-canvas-opened-by-search');
        }

        const mobileInput = offCanvas.querySelector('[data-mobile-search-input]');
        mobileInput?.focus();
        setTimeout(() => mobileInput?.focus(), 300);
    },

    openSearch() {
        const navMenu = document.querySelector('[data-nav-menu]');
        const searchInline = document.querySelector('[data-search-inline]');
        const input = searchInline?.querySelector('.header__search-input');
        const header = document.querySelector('.header__content, .header-new__inner');

        if (!navMenu || !searchInline) return;

        navMenu.hidden = true;
        searchInline.hidden = false;
        document.querySelectorAll('[data-search-toggle]').forEach(t => t.setAttribute('aria-expanded', 'true'));
        header?.classList.add('is-search-active');
        document.body.classList.add('search-active');
        input?.focus();
    },

    closeSearch() {
        const navMenu = document.querySelector('[data-nav-menu]');
        const searchInline = document.querySelector('[data-search-inline]');
        const input = searchInline?.querySelector('.header__search-input');
        const header = document.querySelector('.header__content, .header-new__inner');

        if (!navMenu || !searchInline) return;

        navMenu.hidden = false;
        searchInline.hidden = true;
        document.querySelectorAll('[data-search-toggle]').forEach(t => t.setAttribute('aria-expanded', 'false'));
        header?.classList.remove('is-search-active');
        document.body.classList.remove('search-active');
        if (input) input.value = '';
    }
};

export default SearchToggle;
